<template>
  <div class="overMap">
    <q-select
      v-model="selectedUid"
      filled
      clearable
      use-input
      hide-selected
      hide-dropdown-icon
      fill-input
      input-debounce="300"
      :options="options"
      style="width: 250px"
      @input="setSelectedDevice"
      @filter="filterFn"
    >
      <template #no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
      <template #append>
        <q-icon name="search" />
      </template>
    </q-select>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DeviceSearch',
  data() {
    return {
      selectedUid: '',
      options: [] as string[],
    };
  },
  methods: {
    filterFn(inputVal: string, update: any, abort: any) {},
    setSelectedDevice(uid: string) {},
  },
});
</script>

<style scoped>
.overMap {
  position: absolute;
  top: 10px;
  left: 70px;
  z-index: 999;
}
</style>
